export const BRANCH_LOAD_REQUEST = 'BRANCH_LOAD_REQUEST';
export const BRANCH_LOAD_SUCCESS = 'BRANCH_LOAD_SUCCESS';
export const BRANCH_LOAD_FAILURE = 'BRANCH_LOAD_FAILURE';
